import { render, staticRenderFns } from "./ClosedTradeTab.vue?vue&type=template&id=486b28e4"
import script from "./ClosedTradeTab.vue?vue&type=script&lang=js"
export * from "./ClosedTradeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports